import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({ changeDetection: ChangeDetectionStrategy.Eager, selector: 'vs-divider', template: '', standalone: false })
export class DividerComponent {
  @HostBinding('class') styles = 'block h-px w-full bg-gray-200';
}
